export const TILE_PADDING = 24;
export const FOOTER_GRID_HEIGHT = 54 + TILE_PADDING; // footer height: 48px + images block's margin-bottom: 6px => 54px
export const FOOTER_CLUSTER_HEIGHT = 57 + TILE_PADDING;
export const PICTURE_GRID_WIDTH = 56;
export const PICTURE_GRID_GAP = 3;
export const PICTURE_DETAIL_GAP = 6;
export const POSITION_INDICATOR_WIDTH = 33;
export const GRID_ROW_GAP = 12;
export const KEYWORDS_RECAP_HEIGHT = 56;
export const PICTURE_DETAIL_WIDTH = 65; // cluster view' scrollHeight (213px) / 3 rows - 6px margin-top;
const TILE_PADDING_HEIGHT = 48;
const TILE_HEADER_HEIGHT = 92;
export const TILE_OUTER_SPACE = TILE_PADDING_HEIGHT + TILE_HEADER_HEIGHT;
